import clsx from 'clsx';
import React, { forwardRef } from 'react';
import { Slot } from '@radix-ui/react-slot';
import styles, { heading as headingClass } from './heading.module.css';
export const Heading = forwardRef(({ className, lineHeight = 'small', fluid = true, textAlign = 'start', maxWidth, as = 'span', children, variant, style, ...props }, forwardedRef) => {
    const cssVars = {
        '--max-width': maxWidth,
        '--text-align': textAlign
    };
    const Wrapper = as;
    return (React.createElement(Slot, null,
        React.createElement(Wrapper, { "data-heading-variant": variant, "data-heading-line-height": lineHeight, "data-heading-fluid": fluid, ref: forwardedRef, style: { ...cssVars, ...style }, className: clsx(headingClass, styles[as], className), ...props }, children)));
});
Heading.displayName = 'Heading';
